module.exports = __webpack_public_path__ + "static/media/filename (10).eda12690.png";